import React, { FC, MouseEvent } from 'react'
import { Font } from 'is24-corecss'
import './ProductBox.scss'
import { useDispatch, useSelector } from 'react-redux'
import { Intent } from '../../@types/intent'
import { reportTrackingEvent } from '../../tracking/thunks'
import { Button } from '../styled/CosmaButton/CosmaButton'
import { ReduxState } from '../../store/reducers'

type ProductBoxProps = {
  intent: Intent
}

const INDEPENDENT_SALE_AND_PARTIAL_SALE_OBJECT = {
  headline: 'Dein persönlicher Eigentümerbereich',
  link: 'https://atlas.immobilienscout24.de/eigentuemerbereich/?cmp_id=10-051358&cmp_name=residential_atlas_myproperty&cmp_position=residential_realtorleadengine&cmp_creative=myproperty_btn_rle_response',
  buttonText: 'Zum Eigentümerbereich',
  text: 'Behalte deine Immobilie immer im Blick: Im kostenlosen Eigentümerbereich kannst du deine Immobilie anlegen und so die aktuelle Marktentwicklung in deiner Region beobachten sowie Preisupdates verfolgen.',
  reportingEventLabel: '',
}

const letContent = {
  headline: 'Passende Mieter finden',
  link: 'https://www.immobilienscout24.de/anbieten/',
  buttonText: 'Anzeige schalten',
  text: 'Inseriere kostenlos deine Immobilie und finde schnell und unkompliziert passende Mieter.',
  reportingEventLabel: 'exit_to_ppa',
}

const content = {
  [Intent.MAKLER_SALE]: {
    headline: 'Dein persönlicher Eigentümerbereich',
    link: 'https://atlas.immobilienscout24.de/eigentuemerbereich/?cmp_id=10-051358&cmp_name=residential_atlas_myproperty&cmp_position=residential_realtorleadengine&cmp_creative=myproperty_btn_rle_response',
    buttonText: 'Zum Eigentümerbereich',
    text: 'Behalte deine Immobilie immer im Blick: Im kostenlosen Eigentümerbereich kannst du deine Immobilie anlegen und so die aktuelle Marktentwicklung in deiner Region beobachten sowie Preisupdates verfolgen.',
    reportingEventLabel: 'exit_to_myproperty',
  },
  [Intent.LET]: letContent,
  [Intent.MAKLER_LET]: letContent,
  [Intent.MAYBE_MAKLER_LET]: letContent,
  [Intent.INDEPENDENT_LET]: letContent,
  [Intent.BUY]: {
    headline: 'Mehr Sicherheit beim Kauf',
    link: 'https://www.immobilienscout24.de/premium-mitgliedschaft-kauf/leistungen.html?cmp_id=10-051356&cmp_name=premium_buy&cmp_position=residential_realtorleadengine&cmp_creative=premium_buy_btn_rle_response',
    buttonText: 'KäuferPlus freischalten',
    text: 'Mit Plus von ImmoScout24 erhältst du exklusive Funktionen, die dich dabei unterstützen schneller, bequemer und sicherer dein neues Zuhause zu finden.',
    reportingEventLabel: 'exit_to_premium-buy',
  },
  [Intent.RENT]: {
    headline: 'Schneller in dein Traumzuhause mit MieterPlus',
    link: 'https://www.immobilienscout24.de/meinkonto/premium-mitgliedschaft/?cmp_id=10-051357&cmp_name=premium_rent&cmp_position=residential_realtorleadengine&cmp_creative=premium_rent_btn_rle_response',
    buttonText: 'MieterPlus freischalten',
    text: 'Als Plus-Mitglied von ImmoScout24 erhältst du exklusive Funktionen, die dich auf der Suche nach deinem neuen Zuhause unterstützen.',
    reportingEventLabel: 'exit_to_premium-rent',
  },
  [Intent.BUY_WITH_SELL_OPTION]: {
    headline: '',
    link: '',
    buttonText: '',
    text: '',
    reportingEventLabel: '',
  },
  [Intent.MAYBE_MAKLER_SALE]: {
    headline: 'Dein persönlicher Eigentümerbereich',
    link: 'https://atlas.immobilienscout24.de/eigentuemerbereich/?cmp_id=10-051358&cmp_name=residential_atlas_myproperty&cmp_position=residential_realtorleadengine&cmp_creative=myproperty_btn_rle_response',
    buttonText: 'Zum Eigentümerbereich',
    text: 'Behalte deine Immobilie immer im Blick: Im kostenlosen Eigentümerbereich kannst du deine Immobilie anlegen und so die aktuelle Marktentwicklung in deiner Region beobachten sowie Preisupdates verfolgen.',
    reportingEventLabel: 'exit_to_myproperty',
  },
  [Intent.INDEPENDENT_SALE]: INDEPENDENT_SALE_AND_PARTIAL_SALE_OBJECT,
  [Intent.PARTIAL_SALE]: INDEPENDENT_SALE_AND_PARTIAL_SALE_OBJECT,
  [Intent.BUY_MAYBE_WITH_SELL_OPTION]: {
    headline: '',
    link: '',
    buttonText: '',
    text: '',
    reportingEventLabel: '',
  },
  [Intent.INDEPENDENT_WITH_OFFER_SALE]: {
    headline: 'Dein persönlicher Eigentümerbereich',
    link: 'https://atlas.immobilienscout24.de/eigentuemerbereich/?cmp_id=10-051358&cmp_name=residential_atlas_myproperty&cmp_position=residential_realtorleadengine&cmp_creative=myproperty_btn_rle_response',
    buttonText: 'Zum Eigentümerbereich ',
    text: 'Behalte deine Immobilie immer im Blick: Im kostenlosen Eigentümerbereich kannst du deine Immobilie anlegen und so die aktuelle Marktentwicklung in deiner Region beobachten sowie Preisupdates verfolgen.',
    reportingEventLabel: '',
  },
  [Intent.MAYBE_AGENT_SALE]: {
    headline: '',
    link: '',
    buttonText: '',
    text: '',
    reportingEventLabel: '',
  },
}

export const ProductBox: FC<ProductBoxProps> = (props) => {
  const theme = useSelector((state: ReduxState) => state.config.theme)

  const dispatch = useDispatch()

  const handleSubmit = (e: MouseEvent) => {
    e.preventDefault()
    dispatch(
      reportTrackingEvent({
        pageTitle: 'response',
        label: content[props.intent].reportingEventLabel,
        eventName: 'promotion_click',
        inputValue: content[props.intent].reportingEventLabel,
      })
    )
    window.open(content[props.intent].link, '_blank')
  }

  return (
    <div className='grid-flex grid-justify-center padding-top-s'>
      <div className='grid-item one-whole product-box padding-horizontal-xl padding-top-xl padding-bottom-s'>
        <div
          data-testid='product-box-headline'
          className='grid-item one-whole padding-top-s padding-horizontal-s padding-bottom-m'
        >
          <Font className='font-xl'>{content[props.intent].headline}</Font>
        </div>
        <div data-testid='product-box-text' className='grid-item one-whole padding-bottom-l padding-horizontal-s'>
          <Font>{content[props.intent].text}</Font>
        </div>
        <div className='grid-item one-whole padding-bottom-xl padding-top-xs padding-horizontal-s'>
          <Button
            data-testid='product-box-cta'
            onClick={handleSubmit}
            appearance='secondary'
            textColor={theme.text}
            secondaryLight={theme.secondaryLight}
            secondary={theme.secondary}
            primary={theme.primary}
          >
            {content[props.intent].buttonText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ProductBox
